import {WOW} from 'wowjs';

export default {
	init() {
	// JavaScript to be fired on all pages
	const wow = new WOW();
	wow.init();



	var toggleAffix = function(affixElement, scrollElement, wrapper) {

		var height = affixElement.outerHeight(),
		top = wrapper.offset().top;

		if (scrollElement.scrollTop() >= top){
			wrapper.height(height);
			affixElement.addClass('affix');

		}
		else {
			affixElement.removeClass('affix');

			wrapper.height('auto');
		}
	};


	$('.complete-link').click(function() {
		window.location = $(this).find('a').attr('href'); 
		return false;
	});

	$('[data-toggle="affix"]').each(function() {
		var ele = $(this),
		wrapper = $('<div></div>');

		ele.before(wrapper);
		$(window).on('scroll resize', function() {
			toggleAffix(ele, $(this), wrapper);
		});
	});
},
finalize() {
	$(document).ready(function(){
		$('.owl-carousel').owlCarousel({
			loop:false,
			margin:0,
			nav:true,
			dots:true,
			items:1,
			nestedItemSelector:'vc_row',
		});
	});},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js